import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {openAppInModal} from '../services/app-flow';
import {fetchAppIfNeeded} from '../actions/apps';
import {execBI} from '../services/bi-events-manager';
import ALink from './ALink';

const hoverBg = category => {
  const properties = {};
  if (category.hoverBackgroundImage) {
    properties.backgroundImage = `url('${category.hoverBackgroundImage}')`;
  }
  if (category.hoverBackgroundColor) {
    properties.backgroundColor = category.hoverBackgroundColor;
  }
  return properties;
};

const bgImage = category => {
  return category.backgroundImage ? {backgroundImage: `url('${category.backgroundImage}')`} : {};
};

const bgColor = category => {
  return category.backgroundColor ? {backgroundColor: category.backgroundColor} : {};
};

const handleClick = (category, dispatch, biPosition) => {
  return ev => {
    if (category.type === 'app') {
      ev.preventDefault();
      // here we don't have app data and it is needed only for BI
      dispatch(fetchAppIfNeeded(category.slug)).then(action => {
        openAppInModal(action.data.slug);
        execBI('APP_MODAL_OPEN_CLICK', {app: action.data, biPosition, category: 'home'});

      }).catch(() => {
        openAppInModal(category.slug);
      });

    } else {
      execBI('CATEGORY_LINK_CLICK', {category: category.slug, origin: 'home'});
    }
  };
};

let hoverTimeout;
const handleOnHover = (categorySlug) => {
  hoverTimeout = setTimeout(() => execBI('CATEGORY_HOVER', {slug: categorySlug}), 2000);
};
const handleOffHover = () => {
  clearTimeout(hoverTimeout);
};

const CategoryBox = ({category, dispatch, biPosition}) => {
  return (
    <div className="col col-3n">
      <ALink
        to={`/${category.slug}`}
        onClick={handleClick(category, dispatch, biPosition)}
        className={classNames('category-box', category.slug, {'has-background-color': category.backgroundColor})}
        activeClassName="active"
        style={bgColor(category)}
        onMouseEnter={() => handleOnHover(category.slug)}
        onMouseLeave={handleOffHover}
        >

        <div className="background-image" style={bgImage(category)}></div>

        <div className="category-box-content">
          <div className="name">{(!category.smallText && !category.bigText) ? category.name : ''}</div>
          <div className="text-small">{category.smallText}</div>
          <div className="text-large">{category.bigText}</div>
          {category.appsCount ? <div className="apps-count">{category.appsCount} <FormattedMessage id="application.word.apps"/></div> : ''}
        </div>

        <div className="category-box-content-hover" style={hoverBg(category)}>
          <div className="name">{(category.smallText && category.bigText) ? `${category.smallText} ${category.bigText}` : category.name}</div>
          <div className="description">{category.hover}</div>
          <div className="action-container">
            <button type="button" className="call-to-action">{category.cta}</button>
          </div>
        </div>

      </ALink>
    </div>
  );
};

CategoryBox.propTypes = {
  category: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  biPosition: PropTypes.number
};

export default CategoryBox;



// WEBPACK FOOTER //
// ./components/Category-box.js